import { LocalStorage, SessionStorage } from 'core/decorators';

import { SUBSCRIPTION_IS_HIDDEN_BY_USER, SUBSCRIPTION_IS_VERIFIED } from 'site/constants';

export const setSubscriptionIsVerified = () => LocalStorage.setItem(SUBSCRIPTION_IS_VERIFIED, '1');
export const subscriptionIsVerified = () => LocalStorage.getItem(SUBSCRIPTION_IS_VERIFIED) === '1';

export const setSubscriptionIsHiddenByUser = () => SessionStorage.setItem(SUBSCRIPTION_IS_HIDDEN_BY_USER, '1');
export const subscriptionIsHiddenByUser = () => SessionStorage.getItem(SUBSCRIPTION_IS_HIDDEN_BY_USER) === '1';
